import React, { useState } from 'react';
import { Box, Popover, Grid } from '@mui/material';
import { ChromePicker } from 'react-color';

// Couleurs prédéfinies adaptées au thème sombre
const presetColors = [
  '#FFFFFF', // Blanc
  '#90CAF9', // Bleu clair
  '#F48FB1', // Rose
  '#81C784', // Vert
  '#FFB74D', // Orange
  '#BA68C8', // Violet
  '#4FC3F7', // Bleu ciel
  '#FFF176', // Jaune
];

function ColorPicker({ color, onChange, label }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showCustomPicker, setShowCustomPicker] = useState(false);

  const handlePresetClick = (newColor) => {
    onChange(newColor);
  };

  const handleCustomColorChange = (colorResult) => {
    onChange(colorResult.hex);
  };

  const handleClose = () => {
    setShowCustomPicker(false);
    setAnchorEl(null);
  };

  return (
    <Box>
      <Grid container spacing={1} alignItems="center">
        {presetColors.map((presetColor) => (
          <Grid item key={presetColor}>
            <Box
              onClick={() => handlePresetClick(presetColor)}
              sx={{
                width: 35,
                height: 35,
                backgroundColor: presetColor,
                borderRadius: 1,
                cursor: 'pointer',
                border: '3px solid',
                borderColor: color === presetColor ? 'primary.main' : 'grey.700',
                transform: color === presetColor ? 'scale(1.1)' : 'none',
                transition: 'all 0.2s ease',
                '&:hover': {
                  transform: 'scale(1.1)',
                  borderColor: 'primary.main',
                },
              }}
            />
          </Grid>
        ))}
        <Grid item>
          <Box
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setShowCustomPicker(true);
            }}
            sx={{
              width: 35,
              height: 35,
              backgroundColor: !presetColors.includes(color) ? color : 'transparent',
              borderRadius: 1,
              cursor: 'pointer',
              border: '3px solid',
              borderColor: !presetColors.includes(color) ? 'primary.main' : 'grey.700',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                borderColor: 'primary.main',
              },
            }}
          >
            +
          </Box>
        </Grid>
      </Grid>

      <Popover
        open={showCustomPicker}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 1 }}>
          <ChromePicker
            color={color}
            onChange={handleCustomColorChange}
            disableAlpha
          />
        </Box>
      </Popover>
    </Box>
  );
}

export default ColorPicker; 